<template>
  <div>
  <a-modal
    :wrapClassName="isEdit ? 'ps-see-form-modal' : ''"
    :title="title"
    :width="isEdit ? '560px' : '40%'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="year">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.year"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearyear"
            :disabled="isEdit"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="建设总结方案上传" prop="fileName">
          <template v-if="isEdit">
            <span
              v-if="seeFilePath"
              class="ps-see-file-link"
              @click.stop="openFilePreview"
            >{{ seeFileName }}</span>
            <span v-else>--</span>
          </template>
          <a-upload
            v-else
            :file-list="fileList"
            :remove="(file, fileList) => handleRemove(file, fileList)"
            :before-upload="(file, fileList) => beforeUpload(file, fileList)"
            :showUploadList="{
              showRemoveIcon: true,
              showPreviewIcon: true,
            }"
            accept=".pdf"
            @preview="handleFilePreview"
          >
            <a-button :disabled="loading" :loading="loading">
              <a-icon type="upload" />上传附件
            </a-button>
            <span class="text2">注：可上传pdf格式的文件</span>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
  <!-- 挂到 body 的预览弹窗，避免被查看弹窗遮罩挡住 -->
  <a-modal
    :visible="showiframe"
    :footer="null"
    :closable="false"
    :width="960"
    :zIndex="5000"
    :destroyOnClose="true"
    :maskClosable="false"
    :keyboard="true"
    wrapClassName="ps-file-preview-modal"
    :dialogStyle="{ top: '40px', paddingBottom: '0' }"
    @cancel="closeFilePreview"
  >
    <div class="ps-file-preview-body">
      <newpreview
        :previewUrl="previewUrl"
        dialogTitle="建设总结方案预览"
        @closePreview="closeFilePreview"
      />
    </div>
  </a-modal>
</div>
</template>

<script>
import { getAction, postAction, putAction, fileUpdate } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
import newpreview from "@/components/common/newpreviews";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      other: "",
      form: {
        applyId: "",
        // title: "",
        year: "",
        fileName: "",
        filePath: "",
        // achievementType: "",
        // num: "",
        // levelType: "",
        // content: "",
        // courseType: "",
        // otherType: "",
      },
      rules: {
        year: [
          {
            validator: (rule, value, callback) => {
              if (this.form.year != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择活动方案获得年份"));
              }
            },
            required: true,
            message: "请选择活动方案获得年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        fileName: [
          {
            validator: (rule, value, callback) => {
              console.log(value, this.form.joinYear);
              if (this.form.fileName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请上传建设总结方案"));
              }
            },
            required: true,
            message: "请上传建设总结方案",
            trigger: "change",
          },
        ],
        // title: [
        //   {
        //     required: true,
        //     message: "请输入成果名称",
        //     trigger: "blur",
        //   },
        // ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        // num: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
        // levelType: [
        //   {
        //     required: true,
        //     message: "请输入级别",
        //     trigger: "change",
        //   },
        // ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      fileList: [],
      loading: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
      isEdit: false,
      showiframe: false,
      previewUrl: "",
    };
  },
  components: { BaseEditor, newpreview },
  computed: {
    seeFilePath() {
      const f = this.fileList && this.fileList[0];
      return (f && (f.path || f.url)) || this.form.filePath || "";
    },
    seeFileName() {
      const f = this.fileList && this.fileList[0];
      return (f && f.name) || this.form.fileName || "建设总结方案";
    },
  },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
  },
  methods: {
    openFilePreview() {
      this.handleFilePreview({
        path: this.seeFilePath,
        url: this.seeFilePath,
        name: this.seeFileName,
      });
    },
    closeFilePreview() {
      this.showiframe = false;
      this.previewUrl = "";
    },
    handleFilePreview(file) {
      const path =
        (file && (file.path || file.url)) || this.seeFilePath || "";
      if (!path) {
        this.$message.info("暂无文件可预览");
        return;
      }
      this.previewUrl = path;
      // 本组件高层 a-modal（zIndex:5000）打开，盖在查看弹窗之上
      this.$nextTick(() => {
        this.showiframe = true;
      });
    },
    fillFileList(record) {
      this.fileList = [];
      if (!record || !record.filePath) return;
      this.fileList.push({
        path: record.filePath,
        url: record.filePath,
        name: record.fileName || "建设总结方案",
        uid: 1,
        status: "done",
      });
    },
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      this.isEdit = false;
      this.saveText = "保存";
      this.showiframe = false;
      this.previewUrl = "";
      // this.getxwlist();
      //   this.getcgjb();
      // this.getkclist();
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.form.year = new Date().getFullYear() + "";
        this.form.fileName = "";
        this.form.filePath = "";
        this.fileList = [];
        this.title = "新增活动方案";
        this.teacherdata = record;
      } else if (type === "audit-edit") {
        this.title = "编辑活动方案";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.form = {
          title: record?.title,
          applyId: record.applyId,
          year: record.year,
          id: record.id,
          fileName: record.fileName,
          filePath: record.filePath,
        };
        this.fillFileList(record);
      } else if (type === "see" || type === "view" || type === "preview") {
        this.isEdit = true;
        this.title = "查看活动方案";
        this.saveText = "关闭";
        this.form = {
          title: record?.title,
          applyId: record.applyId,
          year: record.year,
          id: record.id,
          fileName: record.fileName,
          filePath: record.filePath,
        };
        this.fillFileList(record);
      } else {
        this.title = "编辑活动方案";
        this.form = {
          title: record?.title,
          // achievementType: record.achievementType,
          // num: record.num,
          //   levelType: record.levelType,
          //   courseType: record.courseType,
          applyId: record.applyId,
          year: record.year,
          id: record.id,
          fileName: record.fileName,
          filePath: record.filePath,
          //   content: record.content,
          //   otherType:record.otherType,
        };
        this.fillFileList(record);
        this.teacherdata = record;
        // if (record.num == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }

        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.form.fileName = "";
      this.form.filePath = "";
      this.fileList = newFileList;
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
      if (this.fileList.length >= 1) {
        this.$message.error("建设总结方案一次只能上传一个文件,请移除后再上传");
        return;
      }
      console.log(file.type, "4444");
      if (file.type != "application/pdf") {
        this.$message.error("请上传规定格式的文件");
        return false;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.form.fileName = file.name;
          this.form.filePath = res.message;
          this.$refs.ruleForm.clearValidate("fileName");
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    blurValue() {
      if (this.form.num == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleClearyear(val) {
      this.form.year = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    handleChange() {
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    openChangeOne(status) {
      if (status && !this.isEdit) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      const year = moment(value).format("YYYY");
      this.form.year = year + "";
      this.yearShowOne = false;
      // this.form.year = value;
      this.$refs.ruleForm.clearValidate("year");
      // this.yearShowOne = false;
    },

    handleCancel() {
      this.showiframe = false;
      this.previewUrl = "";
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level").then(
        (res) => {
          if (res.code == 200) {
            this.jblist = res.result;
          }
        }
      );
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      if (this.isEdit) {
        this.visible = false;
        return;
      }
      //  	this.$refs.ruleForm.clearValidate();
      console.log(typeof this.form.year);
      if (
        typeof this.form.year == "object" &&
        this.form.year != "" &&
        this.type == "add"
      ) {
        this.form.year = new Date(this.form.year).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = this.form;
            //          params.year=new Date(this.form.year).getFullYear()+"";
            params.applyType = this.applyType;
            //params.applyId = "1829722136428707841";
            postAction("/lxbase/lxAnnualPlan/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addGain");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            console.log(
              "🚀 ~ submit ~ this.teacherdata?.status:",
              this.teacherdata?.status
            );
            if (
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              //params.applyId = "1829722136428707841";
              if (typeof this.form.year == "object") {
                params1.year = new Date(this.form.year).getFullYear() + "";
              }
              params1.applyType = this.applyType;
              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addGain");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              //params.applyId = "1829722136428707841";
              if (typeof this.form.year == "object") {
                params.year = new Date(this.form.year).getFullYear() + "";
              }
              params.applyType = this.applyType;
              putAction("/lxbase/lxAnnualPlan/edit", params).then((res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}

.ps-see-file-link {
  color: #e5914b;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  word-break: break-all;

  &:hover {
    color: #c46d2a;
  }
}

.ps-file-preview-body {
  height: 72vh;
  margin: -24px;
}
</style>

<style lang="scss">
.ps-file-preview-modal {
  .ant-modal-body {
    padding: 0;
  }
}
</style>
